/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../../components/global/form create/Popup";
import InputField from "../../components/inputs/inputField";
import InputSelect from "../../components/inputs/InputSelect";
import SelectInput from "../../components/inputs/selectInput";
import UploadPhoto from "../../components/inputs/UploadPhoto";
import { Spinner1 } from "../../components/spinners/Spinner1";
import { imgUrl } from "../../services/api";
import {
  addClient,
  getClient,
  updateClient,
} from "../../services/clintServices";
import { updateAirport } from "../../store/airports";
import { toggleRender } from "../../store/stateSlice";
import { alertMsg } from "../../utilities/helper";

const BannerPopUp = ({
  isOpen,
  toggleModal,
  setOpen,
  setOpenEdit,
  isEdit,
  selectedRow,
}) => {
  //view pupup when onclick "اضافه مطار"
  const dispatch = useDispatch();
  const banners = useSelector((state) => state.banners);
  const [loading, setLoading] = useState(false);
  const airportsId = useSelector((state) => state.airports.id);
  // const airportsDetails = useSelector((state) => state.airports.airports);
  const errorMsgStore = useSelector((state) => state.airports.errorMsg);
  const [errorMsg, seterrorMsg] = useState(errorMsgStore);
  const [file, setFile] = useState("");
  const [values, setValues] = useState({
    render: false,
    image: file,
    status: "",
    target: "",
    banner_type_id: "",
    banner_type: {},
  });
  const [targets, setTargets] = useState([]);
  useEffect(() => {
    setValues({
      render: false,
      image: file,
      status: "",
      target: "",
      banner_type_id: "",
      banner_type: {},
    });
  }, [isOpen]);
  //handle banner type select
  useEffect(() => {
    const targetsOption = banners?.data.map(({ banner_type }) => {
      return { label: banner_type?.name, value: banner_type?.id };
    });
    setTargets(targetsOption);
  }, [banners]);
  //handle selected row
  useEffect(() => {
    if (selectedRow) {
      setValues({ ...values, ...selectedRow });
    }
  }, [selectedRow]);

  //handle upload file
  useEffect(() => {
    setValues({ ...values, image: file });
  }, [file]);

  // Handles file upload event and updates state
  const handleChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
    });
    if (errorMsg !== null) {
      seterrorMsg({ ...errorMsg, [target.name]: null });
    }
  };
  //function to sumbit data
  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (!loading) {
      const editID = isEdit ? "/" + values.id : "";

      let valid = true;
      const { image, status, target, banner_type_id } = values;

      if (!status || !target || !banner_type_id) {
        alertMsg("جميع الحقول مطلوبة", false);
        valid = false;
      }

      if (isEdit) {
        delete values.image;
      }
      if (valid)
        await dispatch(
          addClient({ url: "/banners" + editID, data: values, file: true })
        ).then((res) => {
          if (res.payload.status === "success") {
            dispatch(toggleRender());
            setOpen && setOpen(false);
            setOpenEdit && setOpenEdit(false);
            setValues({ ...values, render: true });
          } else {
            setOpen && setOpen(true);
            setOpenEdit && setOpenEdit(true);

            dispatch(toggleRender());
            setValues({ ...values, render: true });
          }
        });
    }
    setLoading(false);
  };
  //handel error
  useEffect(() => {
    seterrorMsg(errorMsgStore);
  }, [errorMsgStore]);
  const options = [
    {
      value: "active",
      label: "نشطة",
    },
    {
      value: "inactive",
      label: "غير نشطة ",
    },
  ];

  const handelError = (key) => {
    return (
      <span className='text-error'>
        {" "}
        {errorMsg !== null ? errorMsg[key] : null}{" "}
      </span>
    );
  };
  const handleSelectStatus = (e) => {
    setValues({ ...values, status: e.value });
    if (errorMsg !== null && errorMsg !== undefined) {
      seterrorMsg({ ...errorMsg, status: null });
    }
  };
  const handleSelectTarget = (e) => {
    setValues({ ...values, banner_type_id: e.value });
    if (errorMsg !== null && errorMsg !== undefined) {
      seterrorMsg({ ...errorMsg, status: null });
    }
  };
  function handleUpload(e) {
    const file = e.target.files[0];
    setFile(file);
  }

  return (
    <Popup viewPupup={isOpen} hidePupup={toggleModal} viewWidth='content-small'>
      <form className='main-contnt' onSubmit={handleSubmit} disabled={loading}>
        {loading && <Spinner1 />}
        <div className='head-content'>
          <UploadPhoto
            name='image'
            handleUpload={handleUpload}
            file={file}
            isEdit={isEdit}
            image={values.image}
          />
        </div>
        <div className='body-content'>
          <SelectInput
            label='الحاله'
            placeholder={values.status === "active" ? "نشطه" : "غير نشطه"}
            name='status'
            options={options}
            handleSelect={handleSelectStatus}
            note='*'
            status={values.status}
          />
          {handelError("status")}
          <InputField
            value={values.target}
            name='target'
            onChange={handleChange}
            title=' لينك العرض *'
            placeholder='اكتب  لينك العرض *'
            note='*'
          />
          {handelError("target")}

          <SelectInput
            label='نوع العرض'
            placeholder={isEdit ? values.banner_type?.name : ""}
            name='banner_type_id'
            options={targets}
            handleSelect={handleSelectTarget}
            note='*'
            status={values.banner_type_id}
          />
          {handelError("banner type")}
        </div>
        <div className='buttons-contnt display-flex center-flex '>
          <input
            value='اضافه'
            type='submit'
            class='btn btn__primary'
            disabled={loading}
          />
          <div class='btn btn__danger' onClick={toggleModal}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default BannerPopUp;
